module.exports = __webpack_public_path__ + "static/media/homepage.8f88eef1.jpg";